import { writable } from "svelte/store";

export const heroHeight = writable(0);

export const heroTextOptions = writable([
  {
    text: "LOVE & <br/> VALUE <br/> PEOPLE",
    color: "#53BDFF",
  },
  {
    text: "LEADERS <br/> GO <br/> FIRST",
    color: "#93D477",
  },
  {
    text: "JOY IN <br/> THE <br/> JOURNEY",
    color: "#FF2C2D",
  },
]);

export const iterator = writable(0);
